import Stack from '@mui/material/Stack'

import { CategoryIcon, InstitutionLogo, MerchantLogo, Text } from '@mxenabled/mxui'
import { Icon } from '@mxenabled/mx-icons'
import type { Logo, Subtitle } from '../../core'

interface SubHeaderProps {
  subtitle: Subtitle
}

// TODO: Ask backend to send the correct guid (institution_guid, merchant_guid, or category_guid)
// per beat's logo, matching what that beat's subtitle is actually about.
const renderLogo = (logo: Logo | undefined) => {
  if (!logo) return null

  if (logo.logo_name) {
    return <Icon name={logo.logo_name} size={16} sx={{ color: logo.logo_color }} />
  }

  if (logo.merchant_guid) {
    return (
      <MerchantLogo
        alt={logo.merchant_name as string}
        categoryGuid={logo.category_guid as string}
        merchantGuid={logo.merchant_guid}
        size={16}
      />
    )
  }

  if (logo.institution_guid) {
    return (
      <InstitutionLogo
        alt={logo.institution_name as string}
        institutionGuid={logo.institution_guid}
        size={16}
      />
    )
  }

  if (logo.category_guid) {
    return <CategoryIcon categoryGuid={logo.category_guid} size={16} />
  }

  return null
}

const SubHeader = ({ subtitle }: SubHeaderProps) => {
  const { logo, text } = subtitle

  return (
    <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 8 }}>
      {renderLogo(logo)}
      <Text color="text.secondary" variant="body2">
        {text}
      </Text>
    </Stack>
  )
}

export default SubHeader
